export default __webpack_public_path__ + "static/media/bit_bubbles@3x.97a486e3.png";